import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import MyProcessCase from './my-process-case'
import MyProcessCaseModify from './my-process-case-modify'

export default class ReviewCase extends Component {
    render() {
        return (
            <Switch>
                <Route path='/fixcomputer/processcase' component={MyProcessCase} exact /> {/*exact = 路徑完全匹配*/}
                <Route path='/fixcomputer/processcase/modify' component={MyProcessCaseModify} />
                <Redirect to='/fixcomputer/processcase' />
            </Switch>
        )
    }
}